// /**
//  * Accessibility: Keyboard Focus Fixes for Shopify Themes
//  * ---------------------------------------------------------
//  * Include this file just before </body> in theme.liquid:
//  *   {{ 'accessibility-keyboard-focus.js' | asset_url | script_tag }}
//  *
//  * What it does:
//  * 1. Adds a "Skip to content" link if the theme doesn't have one.
//  * 2. Applies a visible focus outline only for keyboard users
//  *    (mouse/touch clicks won't trigger the outline).
//  * 3. Makes non-native clickable elements (divs/spans with
//  *    onclick/data-toggle used as buttons) keyboard-operable.
//  * 4. Traps focus inside open drawers/modals (cart, menu, search)
//  *    and returns focus to the trigger button on close.
//  * 5. Closes any open drawer/modal on Escape.
//  *
//  * Adjust the SELECTORS object below to match your theme's markup.
//  */
// (function () {
//   'use strict';

//   var SELECTORS = {
//     // Elements Shopify themes commonly use as slide-out panels/modals.
//     overlays: [
//       '.drawer', '.cart-drawer', '.menu-drawer',
//       '[data-drawer]', '[data-modal]', '.modal', '.search-modal'
//     ].join(','),
//     // Attribute themes use to mark an overlay as open (adjust if needed).
//     openAttr: 'is-open',        // class name toggled when open
//     focusableWithin:
//       'a[href], button:not([disabled]), input:not([disabled]), ' +
//       'select:not([disabled]), textarea:not([disabled]), ' +
//       '[tabindex]:not([tabindex="-1"])'
//   };

//   /* 1. Skip to content link ------------------------------------------ */
//   function ensureSkipLink() {
//     if (document.querySelector('.skip-to-content-link, [data-skip-link]')) return;
//     var main = document.querySelector('main, #MainContent, [role="main"]');
//     if (!main) return;
//     if (!main.id) main.id = 'MainContent';

//     var link = document.createElement('a');
//     link.href = '#' + main.id;
//     link.textContent = 'Skip to content';
//     link.setAttribute('data-skip-link', '');
//     link.style.cssText =
//       'position:absolute;left:-9999px;top:0;z-index:10000;' +
//       'background:#000;color:#fff;padding:10px 16px;' +
//       'text-decoration:none;border-radius:0 0 4px 0;';
//     link.addEventListener('focus', function () {
//       link.style.left = '0';
//     });
//     link.addEventListener('blur', function () {
//       link.style.left = '-9999px';
//     });
//     document.body.insertBefore(link, document.body.firstChild);
//   }

//   /* 2. Keyboard-only focus outline ------------------------------------ */
//   function setupFocusVisible() {
//     var usingKeyboard = false;

//     document.addEventListener('keydown', function (e) {
//       if (e.key === 'Tab') {
//         usingKeyboard = true;
//         document.body.classList.add('a11y-kb-focus');
//       }
//     });
//     document.addEventListener('mousedown', function () {
//       usingKeyboard = false;
//       document.body.classList.remove('a11y-kb-focus');
//     });

//     var style = document.createElement('style');
//     style.textContent =
//       'body:not(.a11y-kb-focus) *:focus { outline: none; }\n' +
//       'body.a11y-kb-focus *:focus {\n' +
//       '  outline: 3px solid #2e6fdb !important;\n' +
//       '  outline-offset: 2px !important;\n' +
//       '}';
//     document.head.appendChild(style);
//   }

//   /* 3. Make fake "buttons" keyboard operable --------------------------- */
//   function fixFakeButtons() {
//     var candidates = document.querySelectorAll(
//       '[onclick], [data-toggle], [data-drawer-trigger], [data-modal-trigger]'
//     );
//     candidates.forEach(function (el) {
//       var tag = el.tagName.toLowerCase();
//       if (tag === 'a' || tag === 'button' || tag === 'input') return;

//       if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
//       if (!el.hasAttribute('role')) el.setAttribute('role', 'button');

//       el.addEventListener('keydown', function (e) {
//         if (e.key === 'Enter' || e.key === ' ') {
//           e.preventDefault();
//           el.click();
//         }
//       });
//     });
//   }

//   /* 4 & 5. Focus trap + Escape-to-close for drawers/modals ------------- */
//   function setupOverlayFocusTraps() {
//     var lastTrigger = null;

//     // Remember which element opened an overlay (best-effort).
//     document.addEventListener('click', function (e) {
//       var trigger = e.target.closest(
//         '[data-drawer-trigger], [data-modal-trigger], [aria-controls]'
//       );
//       if (trigger) lastTrigger = trigger;
//     });

//     function getOpenOverlay() {
//       var overlays = document.querySelectorAll(SELECTORS.overlays);
//       for (var i = 0; i < overlays.length; i++) {
//         var el = overlays[i];
//         if (
//           el.classList.contains(SELECTORS.openAttr) ||
//           el.getAttribute('aria-hidden') === 'false' ||
//           el.hasAttribute('open')
//         ) {
//           return el;
//         }
//       }
//       return null;
//     }

//     function closeOverlay(el) {
//       el.classList.remove(SELECTORS.openAttr);
//       el.setAttribute('aria-hidden', 'true');
//       if (el.hasAttribute('open')) el.removeAttribute('open');
//       if (lastTrigger) lastTrigger.focus();
//     }

//     document.addEventListener('keydown', function (e) {
//       var overlay = getOpenOverlay();
//       if (!overlay) return;

//       // Escape closes the overlay.
//       if (e.key === 'Escape') {
//         closeOverlay(overlay);
//         return;
//       }

//       // Trap Tab focus inside the overlay.
//       if (e.key === 'Tab') {
//         var focusables = overlay.querySelectorAll(SELECTORS.focusableWithin);
//         if (!focusables.length) return;

//         var first = focusables[0];
//         var last = focusables[focusables.length - 1];

//         if (e.shiftKey && document.activeElement === first) {
//           e.preventDefault();
//           last.focus();
//         } else if (!e.shiftKey && document.activeElement === last) {
//           e.preventDefault();
//           first.focus();
//         }
//       }
//     });

//     // Move focus into the overlay when it becomes visible.
//     var observer = new MutationObserver(function () {
//       var overlay = getOpenOverlay();
//       if (overlay && !overlay.contains(document.activeElement)) {
//         var focusables = overlay.querySelectorAll(SELECTORS.focusableWithin);
//         if (focusables.length) focusables[0].focus();
//       }
//     });
//     document.querySelectorAll(SELECTORS.overlays).forEach(function (el) {
//       observer.observe(el, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
//     });
//   }

//   /* Init ---------------------------------------------------------------- */
//   function init() {
//     ensureSkipLink();
//     setupFocusVisible();
//     fixFakeButtons();
//     setupOverlayFocusTraps();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();

/**
 * Accessibility: Keyboard Focus Fixes for Shopify Themes (v2)
 * ---------------------------------------------------------
 * Include this file just before </body> in theme.liquid:
 *   {{ 'accessibility-keyboard-focus.js' | asset_url | script_tag }}
 *
 * What it does:
 * 1. Applies a visible focus outline only for keyboard users.
 * 2. Makes non-native clickable elements keyboard-operable
 *    (delegated, so it also covers elements injected later by
 *    AJAX — collection filters, quick view, variant swatches).
 * 3. Traps focus inside open drawers/modals and returns focus
 *    to the trigger on close — but only when an overlay is
 *    genuinely visible, to avoid false positives from dormant
 *    modals (search flyout, size chart, notify-me, etc.) that
 *    sit in the DOM at all times.
 * 4. Escape closes any tracked overlay AND any open native
 *    <details> filter accordion, and blurs the active element
 *    ("deselect") when nothing is open.
 *
 * CONFIG: adjust SELECTORS to match your theme's markup if your
 * filters/drawers use different class names than the defaults.
 */
(function () {
  'use strict';

  var SELECTORS = {
    // Named, theme-specific overlay classes. Low risk of colliding with
    // unrelated UI, so these are trusted on their own.
    trustedOverlays: '.cart-drawer, .menu-drawer, .search-modal',
    // Generic overlay-ish selectors. Because '.drawer' / '.modal' /
    // '[data-drawer]' / '[data-modal]' are common enough to collide with
    // non-modal UI (accordions, quick-add panels, swatch states), these
    // are ONLY trapped when the element also carries a genuine dialog
    // signal (see isGenuineDialogSignal below) — never from a class
    // name alone.
    genericOverlays: '.drawer, [data-drawer], [data-modal], .modal',
    get overlays() { return this.trustedOverlays + ', ' + this.genericOverlays; },
    // Class names that, if present on a TRUSTED overlay, mean "this is open".
    openClasses: ['is-open', 'open', 'active', 'show'],
    focusableWithin:
      'a[href], button:not([disabled]), input:not([disabled]), ' +
      'select:not([disabled]), textarea:not([disabled]), ' +
      '[tabindex]:not([tabindex="-1"])',
    // Elements that already handle keyboard natively — never treat as "fake buttons".
    nativeInteractive: 'a, button, input, select, textarea, label, summary'
  };

  /* 1. Keyboard-only focus outline ------------------------------------ */
  function setupFocusVisible() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') document.body.classList.add('a11y-kb-focus');
    });
    document.addEventListener('mousedown', function () {
      document.body.classList.remove('a11y-kb-focus');
    });

    var style = document.createElement('style');
    style.textContent =
      'body:not(.a11y-kb-focus) *:focus { outline: none; }\n' +
      'body.a11y-kb-focus *:focus {\n' +
      '  outline: 3px solid #2e6fdb !important;\n' +
      '  outline-offset: 2px !important;\n' +
      '}';
    document.head.appendChild(style);
  }

  /* 3. Make fake "buttons" keyboard operable (delegated) --------------- */
  // Delegated so it works on elements added later by AJAX (filters, swatches,
  // quick view). Never touches native form controls, so checkbox/radio
  // filters and swatch <label>s keep their normal browser behavior.
  function fixFakeButtons() {
    function isFakeButtonTarget(el) {
      if (!el || !(el instanceof Element)) return false;
      if (el.closest(SELECTORS.nativeInteractive)) return false;
      return el.matches('[onclick], [data-toggle], [data-drawer-trigger], [data-modal-trigger]');
    }

    function ensureOperable(el) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
    }

    // Tag candidates as they appear, so tabindex/role are present even
    // before the user interacts (helps screen reader / tab-order users).
    function scan(root) {
      root.querySelectorAll('[onclick], [data-toggle], [data-drawer-trigger], [data-modal-trigger]')
        .forEach(function (el) {
          if (isFakeButtonTarget(el)) ensureOperable(el);
        });
    }
    scan(document);

    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node.parentNode || document);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target.closest('[onclick], [data-toggle], [data-drawer-trigger], [data-modal-trigger]');
      if (!isFakeButtonTarget(el)) return;
      e.preventDefault();
      el.click();
    });
  }

  /* 4 & 5. Focus trap + Escape for drawers/modals ------------------------ */
  function setupOverlayFocusTraps() {
    var lastTrigger = null;
    var wasOpen = new WeakSet(); // tracks which overlays we last saw as open

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(
        '[data-drawer-trigger], [data-modal-trigger], [aria-controls]'
      );
      if (trigger) lastTrigger = trigger;
    });

    // True only for elements that unambiguously ARE a dialog/overlay,
    // regardless of what generic utility classes they happen to carry.
    function isGenuineDialogSignal(el) {
      return (
        el.getAttribute('role') === 'dialog' ||
        el.getAttribute('role') === 'alertdialog' ||
        el.getAttribute('aria-modal') === 'true' ||
        el.tagName === 'DIALOG' ||
        el.hasAttribute('data-focus-trap') // manual opt-in for theme devs
      );
    }

    function isVisiblyOpen(el) {
      if (el.hasAttribute('data-no-focus-trap')) return false; // manual opt-out

      var isTrusted = el.matches(SELECTORS.trustedOverlays);
      var hasOpenClass = SELECTORS.openClasses.some(function (c) {
        return el.classList.contains(c);
      });
      var flaggedOpen =
        hasOpenClass ||
        el.getAttribute('aria-hidden') === 'false' ||
        el.hasAttribute('open');
      if (!flaggedOpen) return false;

      // Generic selectors (.drawer, .modal, [data-drawer], [data-modal])
      // need an explicit dialog signal too, so an ordinary panel that
      // merely gains an 'active'/'open'/'show' class isn't mistaken for
      // a real overlay and doesn't trap Tab.
      if (!isTrusted && !isGenuineDialogSignal(el)) return false;

      // Require actual visibility too, so dormant modals that merely have a
      // stray matching class don't get treated as open.
      return el.offsetParent !== null || el.getClientRects().length > 0;
    }

    function getOpenOverlay() {
      var overlays = document.querySelectorAll(SELECTORS.overlays);
      for (var i = 0; i < overlays.length; i++) {
        if (isVisiblyOpen(overlays[i])) return overlays[i];
      }
      return null;
    }

    function closeOverlay(el) {
      SELECTORS.openClasses.forEach(function (c) { el.classList.remove(c); });
      el.setAttribute('aria-hidden', 'true');
      if (el.hasAttribute('open')) el.removeAttribute('open');
      wasOpen.delete(el);
      if (lastTrigger) lastTrigger.focus();
    }

    function closeOpenDetails() {
      document.querySelectorAll('details[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var overlay = getOpenOverlay();
        if (overlay) {
          closeOverlay(overlay);
        } else {
          // Nothing tracked as "open" — still deselect: close native
          // <details> filter accordions and blur whatever's focused
          // (e.g. a filter chip or swatch) so it visually deselects.
          closeOpenDetails();
          if (document.activeElement && document.activeElement !== document.body) {
            document.activeElement.blur();
          }
        }
        return;
      }

      if (e.key === 'Tab') {
        var trapOverlay = getOpenOverlay();
        if (!trapOverlay) return;
        var focusables = trapOverlay.querySelectorAll(SELECTORS.focusableWithin);
        if (!focusables.length) return;

        var first = focusables[0];
        var last = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // Move focus into an overlay only on the closed -> open transition,
    // never on incidental attribute churn while it's already open/closed.
    var observer = new MutationObserver(function () {
      document.querySelectorAll(SELECTORS.overlays).forEach(function (el) {
        var open = isVisiblyOpen(el);
        if (open && !wasOpen.has(el)) {
          wasOpen.add(el);
          if (!el.contains(document.activeElement)) {
            var focusables = el.querySelectorAll(SELECTORS.focusableWithin);
            if (focusables.length) focusables[0].focus();
          }
        } else if (!open && wasOpen.has(el)) {
          wasOpen.delete(el);
        }
      });
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'open'],
      subtree: true
    });
  }

  /* Init ---------------------------------------------------------------- */
  function init() {
    setupFocusVisible();
    fixFakeButtons();
    setupOverlayFocusTraps();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();